import React from 'react'
import {NavLink} from "react-router-dom";

const SidebarMenu = () => {
    return (
        <div className="front-sidebar-menu">
            <div className="front-sidebar-menu-list">
                <NavLink to="/backoffice" className="front-header-link">
                    Aanbod
                </NavLink>
                <NavLink to="/backoffice" className="front-header-link">
                    Vestigingen
                </NavLink>
                <NavLink to="/voor-verhuurbedrijven" className="front-header-link">
                    Voor verhuurbedrijven
                </NavLink>
                <NavLink to="/voor-particulieren" className="front-header-link">
                    Voor particulieren
                </NavLink>
                <NavLink to="/backoffice" className="front-header-link">
                    Huren per uur
                </NavLink>
                <NavLink to="/backoffice" className="front-header-link">
                    Over KAV2GO
                    <i className="bi bi-chevron-down ms-2" aria-hidden="true"/>
                </NavLink>
                <div>
                    <i style={{fontSize: '24px'}} className="bi bi-search" aria-hidden="true"/>
                </div>
            </div>
        </div>
    )
}

export default SidebarMenu
